import { Suspense, lazy } from 'react';
import { useEffect } from 'react';
import ErrorPage from './pages/ErrorPage';

// lazy imports ...
const LandingStandings = lazy(() => import('./pages/LandingStandings'));
const LandingShotmaps = lazy(() => import('./pages/LandingShotmaps'));
const Results = lazy(() => import('./pages/Results'));
const PrematchDetails = lazy(() => import('./pages/PrematchDetails'));
const Standings = lazy(() => import('./pages/Standings'));
const MatchDetails = lazy(() => import('./pages/MatchDetails'));
const TeamPage = lazy(() => import('./pages/TeamPage'));
const Competition = lazy(() => import('./pages/Competition'));
const Player = lazy(() => import('./pages/Player'));
const CompetitionWeb = lazy(() => import('./web/CompetitionWeb'));
const PrematchWeb = lazy(() => import('./web/PrematchWeb'));
const TeamWeb = lazy(() => import('./web/TeamWeb'));
const ShotMap = lazy(() => import('./components/player/ShotMap'));
const Referee = lazy(() => import('./shared/RefereeProfile'));
const Venue = lazy(() => import('./shared/VenueProfile'));

export const routes = [
  {
    path: '/',
    element: (
      <ThemeWrapper>
        <Suspense fallback={<div>Učitavanje...</div>}>
          <LandingStandings />
        </Suspense>
      </ThemeWrapper>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/landing/shotmap',
    element: (
      <ThemeWrapper>
        <Suspense fallback={<div>Učitavanje...</div>}>
          <LandingShotmaps />
        </Suspense>
      </ThemeWrapper>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/shotmap-widget',
    element: (
      <ThemeWrapper>
        <Suspense fallback={<div>Učitavanje...</div>}>
          <ShotMap />
        </Suspense>
      </ThemeWrapper>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/prematch/:matchId',
    element: (
      <ThemeWrapper>
        <Suspense fallback={<div>Učitavanje...</div>}>
          <PrematchDetails />
        </Suspense>
      </ThemeWrapper>
    ),
    errorElement: <ErrorPage />,
  },
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/standings',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Standings />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/match/:matchId',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <MatchDetails />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/results',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Results />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/team/:teamId',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <TeamPage />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/competition/:shortname',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Competition />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/player/:playerId',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Player />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: 'referee/:refereeId',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Referee />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: 'venue/:venueId',
        element: (
          <ThemeWrapper>
            <Suspense fallback={<div>Učitavanje...</div>}>
              <Venue />
            </Suspense>
          </ThemeWrapper>
        ),
      },
      {
        path: '/web',
        children: [
          {
            path: 'competition/:shortname',
            element: (
              <ThemeWrapper>
                <Suspense fallback={<div>Učitavanje...</div>}>
                  <CompetitionWeb />
                </Suspense>
              </ThemeWrapper>
            ),
          },
          {
            path: 'team/:teamId',
            element: (
              <ThemeWrapper>
                <Suspense fallback={<div>Učitavanje...</div>}>
                  <TeamWeb />
                </Suspense>
              </ThemeWrapper>
            ),
          },
          {
            path: 'prematch/:matchId',
            element: (
              <ThemeWrapper>
                <Suspense fallback={<div>Učitavanje...</div>}>
                  <PrematchWeb />
                </Suspense>
              </ThemeWrapper>
            ),
          },
        ],
      },
    ],
  },
];

export default function ThemeWrapper({ children }) {
  useEffect(() => {
    function applyTheme(theme) {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }

    const params = new URLSearchParams(window.location.search);
    const themeParam = params.get('theme');

    let theme = 'light'; // default

    if (themeParam === 'dark') {
      theme = 'dark';
      localStorage.setItem('theme', 'dark');
    } else if (themeParam === 'light') {
      theme = 'light';
      localStorage.setItem('theme', 'light');
    } else {
      // No URL param → check localStorage
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        theme = savedTheme;
      } else if (window.APP_THEME) {
        // Mobile app can set this global value
        theme = window.APP_THEME === 'dark' ? 'dark' : 'light';
      }
    }

    applyTheme(theme);
  }, []); // runs once on mount

  return <>{children}</>;
}

// export default function ThemeWrapper({ children }) {
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const isDark = params.get('dark') === '1';

//     if (isDark) {
//       document.documentElement.classList.add('dark');
//     } else {
//       document.documentElement.classList.remove('dark');
//     }
//   }, []);

//   return <>{children}</>;
// }

//local storage option - keeps dark=1 or =0 when shuffling through the screens

// export default function ThemeWrapper({ children }) {
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const darkParam = params.get('dark');

//     if (darkParam === '1') {
//       document.documentElement.classList.add('dark');
//       localStorage.setItem('theme', 'dark'); // save preference
//     } else if (darkParam === '0') {
//       document.documentElement.classList.remove('dark');
//       localStorage.setItem('theme', 'light');
//     } else {
//       // No param? -> fall back to localStorage
//       const savedTheme = localStorage.getItem('theme');
//       if (savedTheme === 'dark') {
//         document.documentElement.classList.add('dark');
//       } else {
//         document.documentElement.classList.remove('dark');
//       }
//     }
//   }, []);

//   return <>{children}</>;
// }
